import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="footer-inner">
        <p className="footer-copy">© {new Date().getFullYear()} Ravindra Birla — built with React</p>
        <div className="footer-links">
          <a href="https://github.com/Birlaravi/" target="_blank" rel="noopener noreferrer">GitHub</a>
          <a href="https://www.linkedin.com/in/ravindra-birla-5a6a281b4" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href="mailto:ravindrabirla20@gmail.com">Email</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
